var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H11C12.1046 16 13 15.1046 13 14V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V14H2V2H11V4C11 4.55228 11.4477 5 12 5C12.5523 5 13 4.55229 13 4V2C13 0.89543 12.1046 0 11 0H2ZM16.7071 4.29289C16.3166 3.90237 15.6834 3.90237 15.2929 4.29289C14.9024 4.68342 14.9024 5.31658 15.2929 5.70711L16.5858 7H7C6.44772 7 6 7.4477 6 8C6 8.5523 6.44772 9 7 9H16.5858L15.2929 10.2929C14.9024 10.6834 14.9024 11.3166 15.2929 11.7071C15.6834 12.0976 16.3166 12.0976 16.7071 11.7071L19.7071 8.7071C20.0976 8.3166 20.0976 7.6834 19.7071 7.2929L16.7071 4.29289Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b2681b0c04884cb04c131e43a94ce198.svg";
export { ForwardRef as ReactComponent };